var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronLeftSvg from './chevron-left.icon.svg';
export const ChevronLeftIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronLeftSvg });
};
_react_refresh_temp_1 = ChevronLeftIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronLeftIcon");
